import { BeneficiaryContactDetailsFormModel } from './beneficiary-contact-details-form.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Beneficjent } from '../../../../models/beneficjent';
import { SharedValidators } from '../../../../validators/shared-validators';

export class BeneficiaryContactDetailsFormBuilder {
  public static createFormGroup(
    user: Beneficjent,
  ): FormGroup<BeneficiaryContactDetailsFormModel> {
    return new FormGroup<BeneficiaryContactDetailsFormModel>({
      telefon1: new FormControl(user?.telefon1, [
        SharedValidators.doNotBeginWithWhitespace(),
        SharedValidators.phoneNumberPatternValidator(),
      ]),
      telefon2: new FormControl(user?.telefon2, [
        SharedValidators.doNotBeginWithWhitespace(),
        SharedValidators.phoneNumberPatternValidator(),
      ]),
      email: new FormControl(user?.email, [
        Validators.required,
        SharedValidators.doNotBeginWithWhitespace(),
        SharedValidators.emailValidator(),
      ]),
    });
  }
}
